import React from 'react'
import { Fade } from "react-awesome-reveal";

function About() {
  return (
    <section className="w-full md:h-screen sm:h-full bg-[url('./images/about.jpg')] bg-cover bg-center " id="apropos">
      <Fade delay={100} duration={2000}>
        <div className='bg-black bg-opacity-80 text-white md:h-full pt-[5em] pb-[20em] md:px-[20em]'>

          <div className=' text-center'>
            <h2 className="text-3xl font-bold">L’excellence en installation de quais au Québec</h2>
          </div>

          <div className='w-full m-auto text-center md:pt-0 px-8 mt-[5em]'>
            <h3 className="subtitlel uppercase relative pb-8 md:text-2xl font-bold">
              POURQUOI LES GENS NOUS CHOISISSENT
            </h3>
            <h2 className='sm:text-3xl text-xl font-bold'>
              Bienvenue chez Quais Danroc
            </h2>
            <p className='mt-8 text-xl'>votre partenaire de confiance pour la mise a l’eau et le
              remisage de vos quais ainsi que la conception et la mise en place de vos milles
              et un projets. Nous offrons des solutions sur mesures qui sauront répondre à
              toutes vos demandes! Bonne visite et à bientôt !
            </p>

            <div className='flex mt-8'>
              <div>
                <h6 className=' text-xl font-bold'>Dany Sévigny</h6>
                <span>(819)822-5760</span>
              </div>
              <div className=' absolute md:right-[22em] right-[2em]'>
                <h6 className=' text-xl font-bold'>Mathieu Cloutier</h6>
                <span>(819)674-3090</span>
              </div>
            </div>

          </div>
        </div>
      </Fade>
    </section>
  )
}

export default About